<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <tracking-progress :transDataSet="transDate"></tracking-progress>
      <form @submit.prevent="submitForm">
      <div class="join container">
        <div class="joinTitle">
          <h3>본인인증</h3>
          <p class="warn">필수입력정보입니다.</p>
        </div>
          <div class="joinContext first userInput">
            <div class="article require mb-19">
              <div class="inputHeader">
              <p>이름</p>
            </div>
            <div class="dataBox">
              <p>{{form.userName.value}}</p>
            </div>
            </div>
            <div class="article require mb-19">
              <div class="inputHeader">
                <p>생년월일</p>
              </div>
              <div class="dataBox">
                <p>{{form.birthDate.value | formatBirth}}</p>
              </div>
            </div>
            <div class="article require telHide">
              <div class="inputHeader">
                <p>연락처</p>
              </div>
              <div class="dataBox">
                <p>{{form.tel.value | formatPhone}}</p>
              </div>
            </div>
            <div class="joinContext">
              <div class="warnSpace">
                <p class="warn"  v-text="form.mail.errorTxt" v-if="form.mail.hasError"></p>
              </div>
              <div class="article require half" :class="{errorLaise : form.mail.hasError}">
                <div class="inputHeader">
                  <p>이메일</p>
                </div>
                <div class="halfWrap">
                  <input type="text" v-model="mailInput.value" @keyup="blurMailInput()">
                  <span class="narrow">@</span>
                  <input type="text" v-model="mailInput2.value" @keyup="blurMailInput2()"/>
                </div>
              </div>
            </div>
            <div class="warnSpace">
              <p class="warn" :class="{possible : idCheckButton}" v-text="form.id.message"></p>
            </div>
            <div class="article require" :class="{errorLaise : form.id.active}">
              <div class="inputHeader">
                <p>아이디</p>
              </div>
              <input  type="text" v-model="form.id.value" maxlength="20"  placeholder="아이디를 입력해주세요." @keyup ="blurId()" class="idInput"/>
              <button type="button" :class="{possible : idCheckButton }" class="authorized" @click="checkJoinId">중복확인</button>
              <span class="imgWrap idPossible" v-if="idCheckButton">
                <img src="@/assets/images/ck_on.svg">
              </span>
            </div>
            <div class="warnSpace">
              <p class="warn"  v-text="form.password.errorTxt" v-if="form.password.hasError"></p>
            </div>
            <div class="article require" :class="{errorLaise : form.password.hasError}">
              <div class="inputHeader">
                <p>비밀번호</p>
              </div>
              <input type="password" v-model="form.password.value" maxlength="20" @keyup="blurPassword()"  placeholder="비밀번호를 입력해주세요." class="pwInput"/>
            </div>
            <div class="warnSpace">
              <p class="warn"  v-text="form.passwordConfirm.errorTxt" v-if="form.passwordConfirm.hasError"></p>
            </div>
            <div class="article require" :class="{errorLaise : form.passwordConfirm.hasError}">
              <div class="inputHeader">
                <p>비밀번호확인</p>
              </div>
              <input type="password" v-model="form.passwordConfirm.value" maxlength="20" @keyup="blurPasswordConfirm()" placeholder="비밀번호 확인을 입력해주세요." class="pwConfirmInput"/>
            </div>
            <!--<div class="article require">
              <p>성별</p><div class="radioWrap"><div class="item"><input type="radio" id="man" name="gender"  v-model="form.gender.value" value="T"><label for="man">남성</label></div>
              <div class="item"><input type="radio" id="women" name="gender" value="F" v-model="form.gender.value"><label for="women">여성</label></div>
            </div>
            </div>-->
            <!--<div class="article require">
              <p>전화번호</p><input  type="text" v-model="form.tel.value" maxlength="22" @blur="blurTel()" />
            </div>-->
            <!--<div class="article require">
              <p>생년월일</p><input type="text"  v-model="form.birthDate.value" @blur="blurBirthDate()" />
            </div>
            <div class="article require">
              <p>기기토큰</p> <input type="text"  v-model="form.deviceToken.value" @blur="blurDeviceToken()" />
            </div>-->
            <!--<p class="warn"
               v-if="form.userName.hasError" v-text="form.userName.errorTxt"></p>
              <p class="warn"
                 v-if="form.gender.hasError" v-text="form.gender.errorTxt"></p>
            <p class="warn"
               v-if="form.tel.hasError" v-text="form.tel.errorTxt"></p>

            <p class="warn"
               v-if="form.birthDate.hasError" v-text="form.birthDate.errorTxt"></p>
            <p class="warn"
               v-if="form.deviceToken.hasError" v-text="form.deviceToken.errorTxt"></p>-->
          </div>

      </div>
        <div class="btnWrap" :class="{visible : idCheckButton && form.id.flag && form.password.flag && form.passwordConfirm.flag && form.mail.flag }">
          <button type="submit">회원가입 완료</button>
        </div>
        </form>
      </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>
<script>
import AppHeader from '../../components/AppHeader'
import AppSidebar from '../../components/AppSidebar'
import TrackingProgress from '../../components/TrackingProgress'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '회원가입',
        progressNum: '50%',
        chapterNum: 2,
        prevUrl: '/authorized'
      },
      pwChecked: false,
      underAgeChecked: false,
      overAgeChecked: false,
      buttonUp: false,
      alertFailMessage: '사용할 수 없는 아이디 입니다.',
      idCheckButton: false,
      alertSuccessMessage: '사용가능한 아이디',
      setCount: false,
      mailInput: {
        value: '',
        flag: false
      },
      mailInput2: {
        value: '',
        flag: false
      },
      form: {
        id: {
          value: '',
          flag: false,
          active: false,
          message: '',
          hasError: false,
          errorTxt: '필수 항목입니다.',
          hasPossible: false,
          possibleTxt: ''
        },
        mutateId: {
          value: '',
          flag: false
        },
        idConfirm: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        password: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        passwordConfirm: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        mail: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        gender: {
          value: '',
          data: ''
        },
        tel: {
          value: ''
        },
        birthDate: {
          value: ''
        },
        userName: {
          value: ''
        },
        isTemporaryMember: {
          value: false
        },
        dupInfo: {
          value: ''
        }
      }
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    TrackingProgress,
    AddPopup
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters('identity', [
      'getSuccess',
      'getDup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('identity', [
      'SET_IDENTITY_SUCCESS'
    ]),
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    blurId () {
      this.form.id.flag = false
      this.idCheckButton = false
      this.checkId()
    },
    checkId () {
      if (this.form.id.flag) return true
      const id = this.form.id.value.replace(/\s/gi, '')
      if (id === '') {
        this.form.id.active = true
        this.form.id.message = '아이디를 입력해주세요.'
        return false
      }
      const isHan = /^[a-zA-Z0-9]{5,19}$/g

      if (!isHan.test(id)) {
        this.form.id.active = true
        this.form.id.message = '아이디는 6~20자의 영문자 또는 숫자로 설정해주세요.'
        this.form.id.flag = false
        return false
      }
      this.form.id.flag = true
      this.form.id.active = false
      this.form.id.message = ''
      return true
    },
    blurPassword () {
      this.form.password.flag = false
      this.checkPw()
    },
    checkPw () {
      if (this.form.password.flag) return true
      const password = this.form.password.value.replace(/\s/gi, '')
      if (password === '') {
        this.form.password.hasError = true
        this.form.password.errorTxt = '비밀번호를 입력해주세요.'
        return false
      }
      const isPw = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$/
      if (!isPw.test(password)) {
        this.form.password.hasError = true
        this.form.password.flag = false
        this.form.password.errorTxt = '비밀번호는 영문대/소문자+숫자 조합으로 8~20자를 설정해주세요.'
        return false
      }
      /*  */
      this.form.password.flag = true
      this.form.password.hasError = false
      this.form.password.errorTxt = ''
      if (this.pwChecked) {
        this.blurPasswordConfirm()
      }
      return true
    },
    blurPasswordConfirm () {
      this.form.passwordConfirm.flag = false
      this.checkPwConfirm()
      console.log('비밀번호체크')
    },
    checkPwConfirm () {
      if (this.form.passwordConfirm.flag) return true
      const password = this.form.passwordConfirm.value.replace(/\s/gi, '')
      if (password === '') {
        this.form.passwordConfirm.hasError = true
        this.form.passwordConfirm.errorTxt = '비밀번호 확인을 입력해주세요.'
        return false
      }
      if (password !== this.form.password.value) {
        this.form.passwordConfirm.flag = false
        this.form.passwordConfirm.hasError = true
        this.form.passwordConfirm.errorTxt = '비밀번호가 일치하지 않습니다.'
        return false
      }
      this.form.passwordConfirm.flag = true
      this.form.passwordConfirm.hasError = false
      this.form.passwordConfirm.errorTxt = ''
      this.pwChecked = true
      return true
    },
    blurMailInput () {
      this.form.mail.flag = false
      this.checkMailInput()
    },
    checkMailInput () {
      if (this.form.mail.flag) return true
      const input = this.mailInput.value.replace(/\s/gi, '')
      if (input === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      this.mailInput.flag = true
      this.blurMail()
      return true
    },
    blurMailInput2 () {
      this.form.mail.flag = false
      this.checkMailInput2()
    },
    checkMailInput2 () {
      if (this.form.mail.flag) return true
      const input = this.mailInput2.value.replace(/\s/gi, '')
      if (input === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      this.mailInput2.flag = true
      this.blurMail()
      return true
    },
    blurMail () {
      this.form.mail.flag = false
      this.checkMail()
    },
    checkMail () {
      if (this.form.mail.flag && this.mailInput.flag && this.mailInput2.flag) return true
      const mail = this.mailInput.value + '@' + this.mailInput2.value
      this.form.mail.value = mail
      if (mail === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      // eslint-disable-next-line no-useless-escape
      const isMail = /^[0-9a-zA-Z ]([-_\.]?[0-9a-zA-Z ])*@[0-9a-zA-Z ]([-_\.]?[0-9a-zA-Z ])*\.[a-zA-Z ]{2,3}$/i
      if (!isMail.test(mail)) {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일 형식에 맞지 않습니다.'
        this.form.mail.flag = false
        return false
      }
      this.form.mail.flag = true
      this.form.mail.hasError = false
      this.form.mail.errorTxt = ''
      return true
    },
    ...mapActions([
      'ID_CHECK',
      'TRANS_USER_DATA'
    ]),
    ...mapActions('identity', [
      'IS_DUP'
    ]),
    async checkJoinId () {
      if (this.form.id.value === '') {
        this.SET_POPUP(true)
        this.popupSet.content = '아이디를 입력해주세요.'
        return false
      }
      const isHan = /^[a-zA-Z0-9]{5,19}$/g
      if (!isHan.test(this.form.id.value)) {
        this.form.id.active = true
        this.form.id.message = '아이디는 6~20자의 영문자 또는 숫자로 설정해주세요.'
        this.form.id.flag = false
        return false
      }
      try {
        const userData = {
          id: this.form.id.value.replace(/\s/gi, '')
        }
        await this.ID_CHECK(userData)
        this.form.id.flag = true
        this.form.id.active = true
        this.form.id.message = '사용가능한 아이디 입니다.'
        this.idCheckButton = true
        this.form.mutateId.value = userData.id
        this.form.mutateId.flag = true
      } catch (error) {
        if (error.status !== 401) {
          this.form.id.active = true
          this.form.id.message = '사용중인 아이디 입니다.'
          this.form.id.flag = false
          this.idCheckButton = false
          this.form.id.value = ''
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    async transData () {
      this.form.tel.value = this.formatPhoneNumber(this.form.tel.value)
      this.form.birthDate.value = this.formatBirthNumber(this.form.birthDate.value)
      console.log('tel::: ', this.form.tel.value)
      console.log('birthDate::: ', this.form.birthDate.value)
      try {
        const userData = {
          id: this.form.mutateId.value.replace(/\s/gi, ''),
          password: this.form.password.value.replace(/\s/gi, ''),
          birthDate: this.form.birthDate.value,
          userName: this.form.userName.value,
          tel: this.form.tel.value,
          mail: this.form.mail.value.replace(/\s/gi, ''),
          gender: this.form.gender.value,
          isTemporaryMember: this.form.isTemporaryMember.value,
          dupInfo: this.form.dupInfo.value
        }
        await this.TRANS_USER_DATA(userData)
          .then(() => {
            if (sessionStorage.getItem('joinName')) {
              sessionStorage.removeItem('joinName')
            }
            sessionStorage.setItem('joinName', this.form.userName.value)
          })
          .then(() => {
            /* 본인인증 정보 초기화 */
            const userInfo = {
              name: '',
              birthDate: '',
              gender: '',
              mobileno: '',
              dupInfo: ''
            }
            this.SET_IDENTITY_SUCCESS(userInfo)
            this.SET_REFERRER(window.location.href)
            this.$router.push('/joinDone')
            localStorage.removeItem('url')
          }
          )
      } catch (error) {
        if (error.status !== 401) {
          this.SET_POPUP(true)
          if (error.data.response.message === 'User already exists.') {
            this.popupSet.content = '이미 가입된 회원입니다.'
            this.popupSet.closeType = 'action'
            this.popupSet.nextLink = '/login'
            this.popupSet.closeLink = '/login'
            this.popupSet.count = 'another'
            const userInfo = {
              name: '',
              birthDate: '',
              gender: '',
              mobileno: '',
              dupInfo: ''
            }
            this.SET_IDENTITY_SUCCESS(userInfo)
          } else if (error.data.response.message === 'Mail already exists.') {
            this.popupSet.content = '중복된 이메일입니다.'
            this.initMail()
          } else {
            this.popupSet.content = errorParser.parse(error)
            this.initForm()
          }
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    initFlag () {
      this.form.id.active = false
      this.form.id.flag = false
      this.form.id.message = ''
      this.mailInput.flag = false
      this.mailInput2.flag = false
      this.form.mail.flag = false
      this.form.mutateId.flag = false
      this.form.password.flag = false
      this.form.passwordConfirm.flag = false
      this.idCheckButton = false
      this.pwChecked = false
    },
    submitForm () {
      if (this.checkAll()) {
        console.log('입력성공')
        this.transData()
      } else {
        if (!this.form.id.flag) {
          this.popupSet.content = '아이디를 입력해주세요.'
          this.SET_POPUP(true)
          this.form.id.active = true
          this.form.id.message = '아이디를 입력해주세요.'
          // document.querySelector('.idInput').focus()
          return false
        }
        if (!this.idCheckButton) {
          this.popupSet.content = '아이디 중복검사를 해주세요.'
          this.SET_POPUP(true)
          this.form.id.active = true
          this.form.id.message = '아이디 중복검사를 해주세요.'
          // document.querySelector('.idInput').focus()
          return false
        }
        if (!this.form.password.flag) {
          this.popupSet.content = '비밀번호를 확인해주세요.'
          this.SET_POPUP(true)
          this.form.password.hasError = true
          this.form.password.errorTxt = '비밀번호를 확인해주세요.'
          // document.querySelector('.pwInput').focus()
          return false
        }
        if (!this.form.password.flag || !this.form.passwordConfirm.flag) {
          this.popupSet.content = '비밀번호와 비밀번호확인을 체크해주세요.'
          this.SET_POPUP(true)
          this.form.passwordConfirm.hasError = true
          this.form.passwordConfirm.errorTxt = '비밀번호와 비밀번호확인을 체크해주세요.'
          // document.querySelector('.pwConfirmInput').focus()
          return false
        }
        if (!this.form.mail.flag) {
          this.popupSet.content = '이메일을 확인해주세요.'
          this.SET_POPUP(true)
          this.form.mail.hasError = true
          this.form.mail.errorTxt = '이메일을 확인해주세요.'
          // document.querySelector('.mailInput').focus()
          return false
        }
      }
    },
    initForm () {
      this.form.id.value = ''
      this.form.mutateId.value = ''
      this.form.password.value = ''
      this.form.passwordConfirm.value = ''
      this.mailInput.value = ''
      this.mailInput2.value = ''
      this.form.mail.value = ''
      this.initFlag()
    },
    initMail () {
      this.form.mail.value = ''
      this.form.mail.flag = false
    },
    checkAll () {
      return !!(this.form.id.flag && this.form.password.flag &&
        this.form.passwordConfirm.flag && this.form.mail.flag &&
        this.idCheckButton)
    },
    async dubCheck () {
      const dupInfo = this.getSuccess.dupInfo
      const check = {
        dupInfo: dupInfo
      }
      try {
        await this.IS_DUP(check)
          .then(() => {
            if (this.getDup.dupCheck === true) {
              this.SET_POPUP(true)
              this.popupSet.count = 'another'
              this.popupSet.content = '이미 가입된 회원입니다.'
              this.popupSet.closeType = 'action'
              this.popupSet.closeLink = '/login'
              this.popupSet.nextLink = '/login'
              const userInfo = {
                name: '',
                birthDate: '',
                gender: '',
                mobileno: '',
                dupInfo: ''
              }
              this.SET_IDENTITY_SUCCESS(userInfo)
              localStorage.removeItem('url')
            }
          })
      } catch (e) {
        console.log('error: ', e)
      } finally {
      }
    },
    fetchData () {
      if (this.getSuccess.name === '' || this.getSuccess.birthDate === '' || this.getSuccess.gender === '' || this.getSuccess.mobileno === '' || this.getSuccess.dupInfo === '') {
        this.SET_POPUP(true)
        this.popupSet.count = 'another'
        this.popupSet.content = '잘못된 접근입니다.'
        this.popupSet.closeType = 'action'
        this.popupSet.closeLink = '/'
        this.popupSet.nextLink = '/'
      }
      const name = this.getSuccess.name
      const birthDate = this.getSuccess.birthDate
      const gender = this.getSuccess.gender
      const mobileno = this.getSuccess.mobileno
      const dupInfo = this.getSuccess.dupInfo
      if (gender === '0') {
        this.form.gender.value = 'F'
        this.form.gender.data = '여성'
      } else if (gender === '1') {
        this.form.gender.value = 'M'
        this.form.gender.data = '남성'
      }
      this.form.userName.value = name
      this.form.birthDate.value = birthDate
      this.form.tel.value = mobileno
      this.form.dupInfo.value = dupInfo
    },
    formatPhone (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let phone = ''
      if (number.length < 4) {
        return number
      }
      if (number.length < 7) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3)
      } else if (number.length < 11) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 3)
        phone += '-'
        phone += number.substr(6)
      } else {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 4)
        phone += '-'
        phone += number.substr(7)
      }
      return phone
    },
    formatPhoneNumber (obj) {
      this.form.tel.value = this.formatPhone(obj)
      return this.form.tel.value
    },
    formatBirth (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let birth = ''
      if (number.length < 5) {
        return number
      } else if (number.length < 7) {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 5)
        return birth
      } else {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 2)
        birth += '-'
        birth += number.substr(6, 2)
        return birth
      }
    },
    formatBirthNumber (obj) {
      this.form.birthDate.value = this.formatBirth(obj)
      return this.form.birthDate.value
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/ChoiceType')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.dubCheck()
    this.fetchData()
  },
  filters: {
    formatPhone (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let phone = ''
      if (number.length < 4) {
        return number
      }
      if (number.length < 7) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3)
      } else if (number.length < 11) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 3)
        phone += '-'
        phone += number.substr(6)
      } else {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 4)
        phone += '-'
        phone += number.substr(7)
      }
      return phone
    },
    formatBirth (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let birth = ''
      if (number.length < 5) {
        return number
      } else if (number.length < 7) {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 5)
        return birth
      } else {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 2)
        birth += '-'
        birth += number.substr(6, 2)
        return birth
      }
    }
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
  }
}
</script>

<style lang="scss" scoped>
</style>
